// @flow
import { getDefaultLanguage } from 'bil-front-commons/lib/utils/LanguageUtils';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import IntlApp from '../../components/IntlApp';
import { createWindowRedirect } from '../../components/WindowRedirect';
import { keycloackLogoutUrl, sessionStorageRedirectParam } from '../../config/KeycloakConfig';
import { availableLanguages, defaultLanguage } from '../../config/LanguageConfig';
import * as IntlActions from '../../stores/Intl/IntlActions';
import DeviceSelection from '../DeviceSelection/DeviceSelection';
import Execution from '../Execution/Execution';
import LuxtrustConnection from '../LuxtrustConnection/LuxtrustConnection';
import AccountSelection from '../AccountSelection/AccountSelection';
import Summary from '../Summary/Summary';
import Validation from '../Validation/Validation';
import AccountSelection_DEMO from '../AccountSelection/AccountSelection_DEMO';

const redirectUrl = sessionStorage.getItem(sessionStorageRedirectParam);

export class App extends Component {
   render() {
      const {locale, loading, changeLanguage, location, messages} = this.props;

      return (
         <Switch>
            {availableLanguages.map(lang => (
               <Route
                  key={lang}
                  path={`/${lang}`}
                  component={({match}) => (
                     <IntlApp
                        messages={messages}
                        locale={locale}
                        loading={loading}
                        changeLanguage={changeLanguage}
                        routeLocale={lang}>
                        <Switch>

                           <Route
                              exact
                              path={`${match.url}/luxtrust/:mode`}
                              component={LuxtrustConnection}
                           />
                           
                           <Route
                              exact
                              path={`${match.url}/device`}
                              component={DeviceSelection}
                           />

                           <Route
                              exact
                              path={`${match.url}/accounts`}
                              component={AccountSelection}
                           />
                           
                           <Route
                              exact
                              path={`${match.url}/summary`}
                              render={(props) => <Summary {...props} />}
                           />
                           
                           <Route
                              exact
                              path={`${match.url}/result`}
                              render={(props) => <Validation
                                  {...props} />}
                           />

                           <Route
                              exact
                              path={`${match.url}/:paymentReferenceParam(\\b[0-9a-f]{8}\\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\\b[0-9a-f]{12}\\b)`}
                              render={(props) => <Execution
                                  {...props} />}
                           />
                           
                           {/* 
                              DEMO - TO COMMENT FOR RELEASED VERSION
                              =====================================
                              Uncomment for easy debuging, features dev, demo for UX review
                              =====================================
                           */}

                           <Route
                              exact
                              path={`${match.url}/demo`}
                              component={AccountSelection_DEMO}
                           />

                           {/* <Route
                              exact
                              path={`${match.url}/demo/noaccounts`}
                              component={Payment_NO_ACCOUNT_DEMO}
                           /> */}
                           {/* 
                              =====================================
                              =====================================
                           */}

                           <Redirect from="*" to={`${match.url}/result?status=fail`} />

                        </Switch>
                     </IntlApp>
                  )}
               />
            ))}
            {redirectUrl && (
               <Route
                  exact
                  path={keycloackLogoutUrl}
                  component={createWindowRedirect(redirectUrl, () => sessionStorage.removeItem(sessionStorageRedirectParam))}
               />
            )}
            <Redirect
               from="/:paymentReferenceParam"
               to={{
                  pathname: `/${getDefaultLanguage(
                     locale,
                     availableLanguages,
                     defaultLanguage,
                  )}/:paymentReferenceParam`,
                  search: location.search,
               }}
            />
            <Redirect
               from="*"
               to={{
                  pathname: `/${getDefaultLanguage(
                     locale,
                     availableLanguages,
                     defaultLanguage,
                  )}`,
                  search: location.search,
               }}
            />
         </Switch>
      );
   }
}

export default withRouter(
   connect(
      (state) => ({
         locale: state.intl.locale,
         loading: state.intl.loading,
         messages: state.intl.messages,
      }),
      dispatch => ({
         changeLanguage: (language) =>
            dispatch(IntlActions.changeLanguage(language)),
      }),
   )(App),
);
